import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router'
import { observer } from 'mobx-react'

@observer(['globals'])
export default class ProfileMenu extends Component {

  constructor(props, context) {
    super(props, context);

    this.onChange = e => this.setState({ value: e.target.value });

    this.state = { value: '' };
  }

  focusNext() {
    const input = ReactDOM.findDOMNode(this.input);

    if (input) {
      input.focus();
    }
  }

  logout(e) {
    this.props.globals.logout()
  }

  //<li><a href="login.html"><i className="fa fa-sign-out pull-right"></i> Log Out</a></li>

  render() {
    return (
      <ul id="profile-dropdown" className="dropdown-menu dropdown-usermenu pull-right" onChange={ this.onChange } value={ this.state.value } >
        <li><Link to="/admin/profile"> Profile</Link></li>
        <li><a onClick={ this.logout.bind(this) }><i className="fa fa-sign-out pull-right"></i> Log Out</a></li>
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/profileMenu.js